import '../Display.css'

const DateDropdown = (props) => {
    return (
        <select
        className="dropDown"
        onChange={(evt) => props.dayHandler(evt.target.value)}
        value={props.days}>
            <option value={7}>7 days</option>
            <option value={14}>2 weeks</option>
            <option value={30}>1 month</option>
            <option value={60}>2 months</option>
            <option value={90}>3 months</option>
            <option value={120}>4 months</option>
            <option value={180}>6 months</option>
        </select>
    )
}

export default DateDropdown